var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { E_STATUS } from 'src/shared/types';
import styles from './documentActions.module.scss';
import { Icons } from 'src/ui/components/Icons/Icons';
import { COLORS } from 'src/shared/styles/colors';
import { E_ICONS } from 'src/ui/components/Icons/constants';
var ActionItem = function (props) {
    var type = props.type, isActive = props.isActive, isLoading = props.isLoading, className = props.className, onClick = props.onClick, disabled = props.disabled;
    var loadingIconStyle = classNames(styles.loadingAnimation);
    var actionItemStyle = classNames(styles.actionItem, className, 'icon-document-action', isActive && styles.actionActive, isActive && 'icon-document-action-active', // for QA team
    disabled && styles.actionDisabled);
    var handleIconClick = function (e) {
        e.stopPropagation();
        onClick(type);
    };
    var ActionIcon = function () {
        switch (type) {
            case E_STATUS.OK: {
                return isActive ? (_jsx(Icons, { icon: E_ICONS.CHECK_CIRCLE, color: COLORS.GREEN['500'] })) : (_jsx(Icons, { icon: E_ICONS.CHECK, color: COLORS.GRAY['300'] }));
            }
            case E_STATUS.UNKNOWN: {
                return isActive ? (_jsx(Icons, { icon: E_ICONS.QUESTION_CIRCLE, color: COLORS.GRAY['300'] })) : (_jsx(Icons, { icon: E_ICONS.QUESTION, color: COLORS.GRAY['300'] }));
            }
            case E_STATUS.KO: {
                return isActive ? (_jsx(Icons, { icon: E_ICONS.CLOSE_CIRCLE, color: COLORS.RED['500'] })) : (_jsx(Icons, { icon: E_ICONS.CLOSE, color: COLORS.GRAY['300'] }));
            }
            default:
                return null;
        }
    };
    return (_jsx("div", __assign({ role: "none", className: actionItemStyle, onClick: disabled || isActive ? null : handleIconClick, "data-test": "document-action-".concat(type) }, { children: isLoading ? (_jsx(Icons, { icon: E_ICONS.SETTINGS, className: loadingIconStyle, color: COLORS.GRAY['300'] })) : (_jsx(ActionIcon, {})) })));
};
export var DocumentActions = function (props) {
    var status = props.status, locked = props.locked, disabled = props.disabled, isLoading = props.isLoading, onStatusChange = props.onStatusChange;
    var isCancel = status === E_STATUS.KO;
    var isNA = status === E_STATUS.UNKNOWN;
    var isValid = status === E_STATUS.OK;
    return (_jsxs("div", __assign({ className: styles.documentActionsWrapper }, { children: [_jsx(ActionItem, { type: E_STATUS.KO, isActive: isCancel, isLoading: isLoading, disabled: disabled || locked, onClick: onStatusChange }), _jsx(ActionItem, { type: E_STATUS.UNKNOWN, isActive: isNA, isLoading: isLoading, disabled: disabled || locked, onClick: onStatusChange }), _jsx(ActionItem, { type: E_STATUS.OK, isActive: isValid, isLoading: isLoading, disabled: disabled || locked, onClick: onStatusChange })] })));
};
